<template>
  <img :src="require('@/resources/images/BigLoader.png')" width="170" height="170"/>
</template>

<script>
export default {
  name: 'bigLoader',
}
</script>
